import { render } from "./AppointmentModal.vue?vue&type=template&id=4b3b2ba6&scoped=true"
import script from "./AppointmentModal.vue?vue&type=script&lang=ts"
export * from "./AppointmentModal.vue?vue&type=script&lang=ts"

import "./AppointmentModal.vue?vue&type=style&index=0&id=4b3b2ba6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b3b2ba6"

export default script